export const getImageUrl = (imgPath) =>
  imgPath?.startsWith("http")
    ? imgPath
    : `${process.env.REACT_APP_IMAGE_PATH}/${imgPath}`;
